'use client';

import { useEffect, useRef } from 'react';
import { appStateService, StoreBackgroundProps } from '../app.state.service';

/**
 * Publishes the background a page wants onto the shell that renders it, and
 * hands it back when the page unmounts. Pass null while the theme is still
 * loading so the route default stays in place.
 */
export const useBackgroundProps = (props: StoreBackgroundProps | null): void => {
    const latestProps = useRef(props);
    latestProps.current = props;

    const propsKey = props ? JSON.stringify(props) : null;

    useEffect(() => {
        if (!latestProps.current) {
            return;
        }

        appStateService.setBackgroundProps(latestProps.current);

        return appStateService.clearBackgroundProps;
    }, [propsKey]);
};
